module.exports = __webpack_public_path__ + "static/media/26UNRWA22.c5dd9b28.jpg";